import * as React from 'react';
import {ArrowUpRight, Frame, ScanFace, Sparkles} from 'lucide-react';
import {BRAND} from '../brand';

// Lumière Archive (the hedonism_bot app) keeps its own look on every brand:
// ink, gold and Playfair, with the Iris aperture mark.
const INK = '#0f0f0f';
const GOLD = '#c9a96e';
const SERIF = "'Playfair Display', Georgia, serif";

const FEATURES = [
    {Icon: Sparkles, title: 'Curated.', body: 'Our favorite shots, with new ones added after every event we cover.'},
    {Icon: ScanFace, title: 'Find yourself.', body: 'Faces are grouped, so the photos you\'re in are easy to find.'},
    {Icon: Frame, title: 'Take it home.', body: 'Order high-quality prints of any photo you love.'},
];

const LumiereArchive: React.FC = () => {
    const gallery = BRAND.gallery;
    if (!gallery) return null;
    const host = new URL(gallery.url).host;

    return (
        <section id="gallery" className="py-24 relative" style={{backgroundColor: INK}}>
            <div className="max-w-7xl mx-auto px-6">
                <div className="grid grid-cols-1 lg:grid-cols-[auto_1fr] gap-12 items-center">
                    <a href={gallery.url} aria-label="Open Lumière Archive" className="mx-auto lg:mx-0">
                        <img src="/lumiere-mark.svg" alt="" width={176} height={176}
                             className="w-36 h-36 md:w-44 md:h-44 rounded-[22%] shadow-[0_0_60px_rgba(201,169,110,0.25)]"/>
                    </a>

                    <div>
                        <p className="text-xs uppercase tracking-[0.3em] mb-3" style={{color: GOLD}}>Living portfolio</p>
                        <h2 className="text-4xl md:text-5xl text-white mb-4" style={{fontFamily: SERIF}}>
                            Lumière <span className="italic" style={{color: GOLD}}>Archive</span>
                        </h2>
                        <p className="text-gray-400 max-w-2xl text-lg mb-8">{gallery.blurb}</p>

                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mb-10">
                            {FEATURES.map(({Icon, title, body}) => (
                                <div key={title} className="flex gap-3">
                                    <Icon className="w-5 h-5 shrink-0 mt-1" style={{color: GOLD}}/>
                                    <p className="text-gray-400 text-sm">
                                        <span className="text-white font-semibold">{title}</span>{' '}{body}
                                    </p>
                                </div>
                            ))}
                        </div>

                        <a href={gallery.url}
                           className="inline-flex items-center gap-2 px-6 py-3 rounded font-semibold no-underline tracking-wide transition-opacity hover:opacity-90"
                           style={{backgroundColor: GOLD, color: INK}}>
                            Browse {host}
                            <ArrowUpRight className="w-4 h-4"/>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LumiereArchive;
